import { useSearchParams, Link } from 'react-router-dom'
import { useMemo } from 'react'
import { buildRecommendation } from '../data/wizardResult'
import type { StepId } from '../data/wizardSteps'
import { CopyButton } from '../components/CopyButton'

const STEP_IDS: StepId[] = ['device', 'channel', 'goal', 'model']

export function Result() {
  const [searchParams] = useSearchParams()
  const answers = useMemo(() => {
    const a: Record<StepId, string> = {} as Record<StepId, string>
    STEP_IDS.forEach((id) => {
      const v = searchParams.get(id)
      if (v) a[id] = v
    })
    return a
  }, [searchParams])

  const config = useMemo(() => buildRecommendation(answers), [answers])

  return (
    <div className="page">
      <h1 className="section-title">你的专属配置单</h1>
      <p className="lead" style={{ marginBottom: '2rem' }}>
        以下由本地生成，未上传任何数据。请勿在站内填写真实 API Key。
      </p>

      <div className="card">
        <h2>推荐部署方式</h2>
        <p><strong>{config.deployMethod}</strong></p>
        <p style={{ color: 'var(--text-muted)' }}>{config.deployDetail}</p>
        {config.dockerHint && (
          <p style={{ color: 'var(--text-muted)', marginTop: '0.5rem' }}>{config.dockerHint}</p>
        )}
      </div>

      <div className="card">
        <h2>基础 Skills 推荐</h2>
        <ul className="skill-list">
          {config.baseSkills.map((s) => (
            <li key={s.name}><strong>{s.name}</strong> — {s.desc}</li>
          ))}
        </ul>
      </div>

      <div className="card">
        <h2>进阶 Skills 推荐</h2>
        <ul className="skill-list">
          {config.advancedSkills.map((s) => (
            <li key={s.name}><strong>{s.name}</strong> — {s.desc}</li>
          ))}
        </ul>
      </div>

      <div className="card">
        <h2>一键配置命令</h2>
        <div className="command-row">
          <code className="command-block">{config.oneLiner}</code>
          <CopyButton text={config.oneLiner} />
        </div>
      </div>

      <div style={{ marginTop: '2rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
        <Link to="/wizard" className="btn btn-ghost">重新引导</Link>
        <Link to="/deploy" className="btn btn-primary">去部署专区</Link>
      </div>
    </div>
  )
}
